import cn from 'classnames';
import * as React from 'react';

import { SearchedProps } from './types';

const styles = require('./Searched.css');

export const Searched: React.FC<SearchedProps> = props => {
  const { link, count } = props;

  const handleClick = React.useCallback<VoidFunction>(() => {
    // eslint-disable-next-line no-unused-expressions
    window._headerTrackingEvent?.('saved-search');
  }, []);

  return (
    <span className="c-header__searched-mobile-wrap">
      <a className="c-header__searched-mobile" href={link} onClick={handleClick}>
        <span
          className={cn('c-header-active-notification', {
            [styles['display-none']]: !count,
          })}
        />
      </a>
    </span>
  );
};

Searched.displayName = 'Searched';
